/**
 * Product card pack groups and variant dropdowns.
 * Pack cards: dropdown updates all card details in place.
 * PDP pack picker: selecting another pack redirects to that product URL.
 */
(function () {
  function formatPrice(amount) {
    return amount.toLocaleString('en-IN');
  }

  function parsePaise(option, key) {
    const paise = parseInt(option.getAttribute(key), 10);
    return Number.isFinite(paise) ? paise / 100 : 0;
  }

  function updateRegularPriceEl(el, formattedRegular) {
    if (!el || el.closest('.price__sale')) return;
    el.textContent = formattedRegular;
  }

  function ensureCollectionPrepaidSlot(priceAddCart) {
    let prepaid = priceAddCart.querySelector(':scope > .prepaid-price[data-collection-prepaid="true"]');
    if (!prepaid) {
      prepaid = priceAddCart.querySelector(':scope > .prepaid-price');
    }
    if (!prepaid) {
      prepaid = document.createElement('div');
      prepaid.className = 'prepaid-price';
      prepaid.setAttribute('data-collection-prepaid', 'true');
      prepaid.innerHTML = '<span class="prepaid-labels"></span><span class="price-item price-item--prepaid"></span>';
      const priceEl = priceAddCart.querySelector('.price');
      if (priceEl && priceEl.nextSibling) {
        priceAddCart.insertBefore(prepaid, priceEl.nextSibling);
      } else if (priceEl) {
        priceAddCart.appendChild(prepaid);
      } else {
        priceAddCart.prepend(prepaid);
      }
    } else if (prepaid.closest('.price')) {
      const priceEl = priceAddCart.querySelector('.price');
      if (priceEl) {
        priceAddCart.insertBefore(prepaid, priceEl.nextSibling);
      }
    }
    return prepaid;
  }

  function syncPrepaidPrice(productCard, variantPrice) {
    const priceAddCart = productCard.querySelector('.price-add-cart-container');
    if (!priceAddCart || !(variantPrice > 0)) return;

    const prepaid = ensureCollectionPrepaidSlot(priceAddCart);
    const prepaidLabel = prepaid.querySelector('.price-item--prepaid');
    if (!prepaidLabel) return;

    const discountedPrice = Math.round(variantPrice * 0.95);
    prepaidLabel.textContent = '₹' + discountedPrice.toLocaleString('en-IN') + ' with offer!';

    prepaid.removeAttribute('hidden');
    prepaid.hidden = false;
    prepaidLabel.removeAttribute('hidden');
    prepaidLabel.hidden = false;

    prepaid.style.setProperty('display', 'block', 'important');
    prepaid.style.setProperty('visibility', 'visible', 'important');
    prepaid.style.setProperty('opacity', '1', 'important');
    prepaidLabel.style.setProperty('display', 'inline-block', 'important');
    prepaidLabel.style.setProperty('visibility', 'visible', 'important');
    prepaidLabel.style.setProperty('opacity', '1', 'important');
  }

  function updateCardPrices(productCard, variantPrice, comparePrice, comparePricePaise, variantPricePaise) {
    const priceContainer = productCard.querySelector('.price-add-cart-container .price, .card-information .price');
    const isOnSale = comparePrice > variantPrice && comparePrice > 0;

    if (priceContainer) {
      priceContainer.classList.toggle('price--on-sale', isOnSale);
      priceContainer.classList.toggle('price-without-sale', !isOnSale);
    }

    const priceElement = productCard.querySelector('.price__sale .price-item--sale');
    if (priceElement && priceElement.tagName === 'SPAN') {
      priceElement.textContent = '₹' + formatPrice(variantPrice);
    }

    const regularPriceEls = productCard.querySelectorAll('.price__regular .price-item.price-item--regular');
    if (regularPriceEls.length) {
      const baseAmount = comparePrice && comparePrice > 0 ? comparePrice : variantPrice;
      const formattedRegular = '₹' + formatPrice(baseAmount);
      regularPriceEls.forEach(function (el) {
        updateRegularPriceEl(el, formattedRegular);
      });
    }

    const compareAtEls = productCard.querySelectorAll('.price__sale s.price-item.price-item--regular');
    if (compareAtEls.length && comparePrice && comparePrice > variantPrice) {
      const formattedCompare = '₹' + formatPrice(comparePrice);
      compareAtEls.forEach(function (el) {
        if (!el.querySelector('.prepaid-price') && el.tagName === 'S') {
          el.textContent = formattedCompare;
        }
      });
    }

    const discountBadges = productCard.querySelectorAll('[data-discount-badge="true"]');
    if (discountBadges.length) {
      let discountPercent = 0;
      const compareBasePaise = Number.isFinite(comparePricePaise) ? comparePricePaise : Math.round(comparePrice * 100);
      const variantBasePaise = Number.isFinite(variantPricePaise) ? variantPricePaise : Math.round(variantPrice * 100);
      if (compareBasePaise > variantBasePaise && compareBasePaise > 0) {
        discountPercent = Math.round(((compareBasePaise - variantBasePaise) * 100) / compareBasePaise);
      }

      discountBadges.forEach(function (discountBadge) {
        if (discountPercent > 0) {
          discountBadge.textContent = discountPercent + '% OFF';
          discountBadge.style.display = 'block';
        } else {
          discountBadge.style.display = 'none';
        }
      });
    }
  }

  function updateCardImage(productCard, imageSrc, altText) {
    const productImageElement = productCard.querySelector('.card__media img.motion-reduce, .card__media img');
    if (productImageElement && imageSrc) {
      productImageElement.setAttribute('src', imageSrc);
      productImageElement.removeAttribute('srcset');
      if (altText) productImageElement.alt = altText;
    }
  }

  function updatePackCardDetails(selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    if (!selectedOption || selectedOption.disabled) return;

    const productCard = selectElement.closest('.product-card-wrapper');
    if (!productCard) return;

    const title = selectedOption.getAttribute('data-product-title') || '';
    const url = selectedOption.getAttribute('data-product-url') || '';
    const variantImageSrc = selectedOption.getAttribute('data-image');
    const variantPricePaise = parseInt(selectedOption.getAttribute('data-price-paise'), 10);
    const comparePricePaise = parseInt(selectedOption.getAttribute('data-compare-price-paise'), 10);
    const variantPrice = parsePaise(selectedOption, 'data-price-paise');
    const comparePrice = parsePaise(selectedOption, 'data-compare-price-paise');
    const quantity = parseInt(selectedOption.getAttribute('data-quantity') || '1', 10);
    const productId = selectedOption.getAttribute('data-product-id');
    const available = selectedOption.getAttribute('data-available') === 'true';

    productCard.querySelectorAll('.card__heading a').forEach(function (link) {
      if (title) link.textContent = title;
      if (url) link.href = url;
    });

    updateCardImage(productCard, variantImageSrc, title);

    const qtyInput = productCard.querySelector('.quantity-input');
    if (qtyInput) qtyInput.value = quantity;

    const ratingBadge = productCard.querySelector('.bestseller-rating-badge[data-id], .jdgm-preview-badge[data-id]');
    if (ratingBadge && productId) {
      ratingBadge.dataset.id = productId;
      if (typeof window.initBestsellerRatingBadges === 'function') {
        window.initBestsellerRatingBadges(productCard);
      }
    }

    const priceAddCart = productCard.querySelector('.price-add-cart-container');
    if (priceAddCart) {
      ensureCollectionPrepaidSlot(priceAddCart);
    }

    updateCardPrices(productCard, variantPrice, comparePrice, comparePricePaise, variantPricePaise);
    syncPrepaidPrice(productCard, variantPrice);
    updateCardAddButton(productCard, available);
  }

  function updateVariantCardDetails(selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    if (!selectedOption || selectedOption.disabled) return;

    const productCard = selectElement.closest('.product-card-wrapper');
    if (!productCard) return;

    const variantImageSrc = selectedOption.getAttribute('data-image');
    const variantPricePaise = parseInt(selectedOption.getAttribute('data-price-paise'), 10);
    const comparePricePaise = parseInt(selectedOption.getAttribute('data-compare-price-paise'), 10);
    const variantPrice = Number.isFinite(variantPricePaise)
      ? variantPricePaise / 100
      : parseFloat(selectedOption.getAttribute('data-price')) || 0;
    const comparePrice = Number.isFinite(comparePricePaise)
      ? comparePricePaise / 100
      : parseFloat(selectedOption.getAttribute('data-compare-price')) || 0;

    const priceAddCart = productCard.querySelector('.price-add-cart-container');
    if (priceAddCart) {
      ensureCollectionPrepaidSlot(priceAddCart);
    }

    updateCardImage(productCard, variantImageSrc);
    updateCardPrices(productCard, variantPrice, comparePrice, comparePricePaise, variantPricePaise);
    syncPrepaidPrice(productCard, variantPrice);
  }

  function updateCardAddButton(productCard, available) {
    const addBtn = productCard.querySelector('.variant-add-btn');
    const soldBtn = productCard.querySelector('.sold-add-btn');

    if (available) {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.style.display = '';
      }
      if (soldBtn) {
        soldBtn.style.display = 'none';
      }
    } else {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.style.display = 'none';
      }
      if (soldBtn) {
        soldBtn.style.display = '';
      }
    }
  }

  function initPackCardSelects(root) {
    const scope = root || document;
    scope.querySelectorAll('.product-variant-select[data-is-pack-group="true"]').forEach(function (selectElement) {
      if (selectElement.dataset.packInit === 'true') return;
      selectElement.dataset.packInit = 'true';

      updatePackCardDetails(selectElement);
      selectElement.addEventListener('change', function () {
        updatePackCardDetails(selectElement);
      });
    });
  }

  function initVariantCardSelects(root) {
    const scope = root || document;
    scope.querySelectorAll('.product-card-wrapper .product-variant-select:not([data-is-pack-group="true"])').forEach(function (selectElement) {
      if (selectElement.dataset.variantCardInit === 'true') return;
      selectElement.dataset.variantCardInit = 'true';

      updateVariantCardDetails(selectElement);
      selectElement.addEventListener('change', function () {
        updateVariantCardDetails(selectElement);
      });
    });
  }

  function initPrepaidOnLoad(root) {
    const scope = root || document;
    scope.querySelectorAll('.product-card-wrapper .price-add-cart-container').forEach(function (priceAddCart) {
      const productCard = priceAddCart.closest('.product-card-wrapper');
      const selectElement = priceAddCart.querySelector('.product-variant-select');
      if (!productCard || !selectElement) return;

      const selectedOption = selectElement.options[selectElement.selectedIndex];
      if (!selectedOption) return;

      const variantPricePaise = parseInt(selectedOption.getAttribute('data-price-paise'), 10);
      const variantPrice = Number.isFinite(variantPricePaise)
        ? variantPricePaise / 100
        : parseFloat(selectedOption.getAttribute('data-price')) || 0;

      ensureCollectionPrepaidSlot(priceAddCart);
      syncPrepaidPrice(productCard, variantPrice);
    });
  }

  function initPackPickers(root) {
    const scope = root || document;

    scope.querySelectorAll('pack-product-picker[data-pack-group-active="true"]').forEach(function (picker) {
      if (picker.dataset.packPickerInit === 'true') return;
      picker.dataset.packPickerInit = 'true';

      const currentId = String(picker.dataset.currentProductId || '');
      const currentVariantId = String(picker.dataset.currentVariantId || '');

      function shouldRedirectPackOption(productId, variantId, url) {
        if (!url) return false;
        if (productId && productId !== currentId) return true;
        if (variantId && variantId !== currentVariantId) return true;
        return false;
      }

      picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          const productId = String(input.dataset.productId || '');
          const variantId = String(input.dataset.variantId || '');
          const url = input.dataset.productUrl;
          if (shouldRedirectPackOption(productId, variantId, url)) {
            window.location.href = url;
            return;
          }
          if (productId === currentId && variantId === currentVariantId) {
            input.checked = true;
          }
        });

        input.addEventListener('click', function (event) {
          const productId = String(input.dataset.productId || '');
          const variantId = String(input.dataset.variantId || '');
          const url = input.dataset.productUrl;
          if (shouldRedirectPackOption(productId, variantId, url)) {
            event.preventDefault();
            window.location.href = url;
          }
        });
      });

      const dropdown = picker.querySelector('.pack-product-picker__dropdown');
      if (dropdown) {
        dropdown.addEventListener('change', function () {
          const option = dropdown.options[dropdown.selectedIndex];
          if (!option || option.disabled) return;
          const productId = String(option.dataset.productId || '');
          const variantId = String(option.dataset.variantId || '');
          const url = option.dataset.productUrl || option.value;
          if (shouldRedirectPackOption(productId, variantId, url)) {
            window.location.href = url;
          }
        });
      }
    });
  }

  function initProductCardSelectors(root) {
    initPackCardSelects(root);
    initVariantCardSelects(root);
    initPrepaidOnLoad(root);
    initPackPickers(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductCardSelectors();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductCardSelectors(event.target);
  });
})();
